import { Buttons } from "@/ui/Buttons";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-6 py-md-7",
  tagline,
  title,
  description,
  image,
  buttons,
  reverse = false,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div
      className={cn(className, classes.ContentSideImage)}
      data-reverse={reverse}
      data-bs-theme={theme}
    >
      <Container fluid="lg">
        <Row className={cn({ "flex-row-reverse": !reverse })}>
          <Col xs={12} md={7}>
            <div
              className={cn("px-4", {
                "ps-lg-0 pe-lg-6": reverse,
                "pe-lg-0 ps-lg-6": !reverse,
              })}
            >
              <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                <span dangerouslySetInnerHTML={{ __html: tagline }} />
              </Tagline>
              <EditableText path="title" tag="h2" className="mb-4">
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </EditableText>
              <EditableHtml path="description">
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </EditableHtml>
              <Buttons buttons={buttons} className="justify-content-md-start flex-row my-5" />
            </div>
          </Col>
          <Col xs={12} md={5} className="position-relative">
            <div className={classes.img}>
              <EditableImage path="image" src={image} size="372x319" alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
